import actions from "./actions";
import mutations from "./mutations";

export const getInitialState = () => {
  return {
    fileName: null,
    fileType: null,
    newFileName: null,
    modified: false,
    availableFiles: [],
    isApplyingChanges: false,
    savingFile: false,
    editDrives: true,
    editJacquard: true,
    editShaft: true,
    editColorControl: true,
    editPicks: true,
    editHooks: true,
    canSelect: true,
    canSave: true,
    dataAvailable: false
  };
};

export const uptDataModule = {
  state: getInitialState(),
  namespaced: true,
  actions,
  mutations
};
